module.exports = __webpack_public_path__ + "img/yinzhang.9820f83a.png";